<!-- 
Listagem do cadastr de regras ST
-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import RegrastForm from './regrast-form'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            ufori: '',
            ncm: '',
            finalidade: '',
            empty: false,
        }
    },

    computed: {
        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },
        regraList: function () {
            return this.$store.getters.getRegrastList
        }
    },

    methods: {
        handleEdit (ufori, finalidade, ncm) {
            //abre a tela de edicao
            this.crud = SysVars.crudU
            this.finalidade = finalidade 
            this.ncm = ncm
            this.ufori = ufori
            this.showForm = true
        },

        handleIncluir (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudI
            this.codpart = codpart
            this.showForm = true;
        },

        closeForm () {
            this.showForm = false
            this.loadData()
        },

        search (value) {
            //efetua a pesquisa
            this.filter = '{"ncm":{"$like":"' + value + '%25"}}'
            this.loadData()
        },

        async loadData () {
            await this.$store.dispatch('loadRegrastList', { filter: this.filter } )
            if (this.regraList.length == 0) {
                this.empty = true
            } else {this.empty = false}
        },
        textFinalidade (value) {
            if (this.metadata) {
              var item = this.metadata.regrast.finalidade.options.filter(x => x.id === value);
              if (item.length) { return item[0].text }
            } else { return value }
        },
    },

    components: {
        BarList, BarGrid, RegrastForm
    },

    mounted() {
    },

    beforeDestroy() {
    },

    created () {
        this.showForm = false
        this.loadData()
    }
}

</script>

<template>
    <div id="grid">
        <div id="list" v-show="!showForm"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                single-entity="Regra de ICMS ST" 
                plural-entity="Regras de ICMS ST"
                v-on:search="search"
                v-on:new="handleIncluir"
                v-on:refresh="loadData()">
            </bar-list>

            <br>
            <div class="row" v-if="regraList.length > 0">
                <div class="col-md-2 col-2">
                    <v-label label="Estado de Origem"></v-label>
                </div>
                <div class="col-md-2 col-2">    
                    <v-label label="Finalidade"></v-label>
                </div>
                <div class="col-md-1 col-2">
                    <v-label label="NCM"></v-label>
                </div>
                <div class="col-md-4 col-2">
                    <v-label label="Descrição NCM"></v-label>
                </div>
                <div class="col-md-2 col-2">
                </div>              
            </div>
            <hr>
            <alert v-if="empty" type="warning" text="Nenhuma regra de ICMS ST foi encontrada."></alert>
            <div class="height-80" style="overflow: auto">

                <div class="mainbox" v-for="(regra, index) in regraList" v-bind:key="index">
                    <!-- <div v-bind:class="[{ 'mark-red': (regra.stcred === 'I' || regra.stcred === 'B') }, { 'mark-yellow': (regra.stcred === 'A') }, 'mark-green']"></div> -->
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-2">
                                <span class="data-list">{{ regra.ufori }}</span>
                            </div>
                            <div class="col-md-2 col-2">    
                                <span class="data-list">{{ textFinalidade(regra.finalidade) }}</span>
                            </div>
                            <div class="col-md-1 col-2">
                                <span class="data-list">{{ regra.ncm }}</span>
                            </div>
                            <div class="col-md-6 col-2">
                                <span class="data-list">{{ regra.descricao }}</span>
                            </div>
                            <div class="col-md-1 col-2">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(regra.ufori, regra.finalidade, regra.ncm)" 
                                    v-on:view="handleEdit(regra.ufori, regra.finalidade, regra.ncm)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <regrast-form v-if="showForm" :crud="crud" :ufori="ufori" :finalidade="finalidade" :ncm="ncm" v-on:closeform="closeForm"></regrast-form>

    </div>
</template>


<style>


</style>



// WEBPACK FOOTER //
// src/forms/regrast-list.vue